import {
  ExternalMeasurementTagSettingType,
  GoogleTagManagerSetting,
} from 'backend';
import {
  GoogleAnalytics4Setting,
  GoogleGlobalSiteTagPageCommandType,
  UniversalAnalyticsSetting,
} from 'backend';
import { mappedConst } from 'shared';

export const EXTERNAL_MEASUREMENT_TAG_TYPE: mappedConst<ExternalMeasurementTagSettingType> =
  {
    UniversalAnalytics: 'UniversalAnalytics',
    GoogleAnalytics4: 'GoogleAnalytics4',
    GoogleTagManager: 'GoogleTagManager',
  };

export const GTAG_LOAD_SCRIPT_ELEMENT_ID = 'synergyGtagLoadScriptElementId';
export const GTAG_INITIALIZE_SCRIPT_ELEMENT_ID =
  'synergyGtagInitializeScriptElementId';

const GTM_LOAD_SCRIPT_ELEMENT_ID_Prefix = 'synergyGtmLoadScriptElementId';
export const getGtmLoadScriptElementId = (containerId: string) =>
  `${GTM_LOAD_SCRIPT_ELEMENT_ID_Prefix}_${containerId}` as const;

const GTM_DATA_LAYER_NAME_PREFIX = 'dataLayer';
export const getGtmDataLayerName = (containerId: string) =>
  `${GTM_DATA_LAYER_NAME_PREFIX}${containerId.replace('-', '')}` as const;

export const GTAG_PAGE_COMMAND_TYPE: mappedConst<GoogleGlobalSiteTagPageCommandType> =
  {
    config: 'config',
    event: 'event',
    set: 'set',
    get: 'get',
    consent: 'consent',
  };

export type MeasurementSettingHandledByGtag =
  | GoogleAnalytics4Setting
  | UniversalAnalyticsSetting;

// eslint-disable-next-line @typescript-eslint/ban-types
type DataLayer = { [key: string]: object };
const parseDataLayerToJson = (obj: DataLayer): any => {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch {
    return undefined;
  }
};

export const insertDataLayers = (
  dataLayerName: string,
  dataLayers: GoogleTagManagerSetting['dataLayers']
): void => {
  if (!Array.isArray((window as any)[dataLayerName])) {
    (window as any)[dataLayerName] = [];
  }

  dataLayers.forEach((dataLayer) => {
    const data = parseDataLayerToJson(dataLayer);
    if (data) {
      (window as any)[dataLayerName]?.push(data);
    }
  });
};
